import { useMemo } from 'react';
import { useAuth } from './AuthContext';
import { route } from './route';

const useFilteredRoutes = () => {
  const { hasPermission } = useAuth();
  return useMemo(() => {
    return route.filter((item) => item.requiredActions.every((scope) => hasPermission(item.requiredModule, scope)));
  }, [hasPermission]);
};

export default useFilteredRoutes;
